import { Config } from 'config';

export const getGoogleLoginUrl = () => {
  const stingifiedParams = new URLSearchParams({
    prompt: 'consent',
    response_type: 'code',
    access_type: 'offline',
    client_id: Config.google.clientId!,
    redirect_uri: Config.google.authRedirectURI!,
    scope: [
      'https://www.googleapis.com/auth/userinfo.email',
      'https://www.googleapis.com/auth/userinfo.profile',
    ].join(' '),
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${stingifiedParams.toString()}`;
};

export const parseQuery = (search: string) => {
  const urlParams = new URLSearchParams(search);
  const error = urlParams.get('error');
  const code = urlParams.get('code');

  if (error) {
    return { error: error, googleAuthCode: undefined };
  }
  if (code) {
    return { error: undefined, googleAuthCode: code };
  }

  return { error: undefined, googleAuthCode: undefined };
};
